import React from "react";

import { Box, Typography, IconButton, Chip, Tooltip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PublishIcon from "@mui/icons-material/Publish";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";

import DataTable from "../../ui/Table";

function ProjectTable({
  projects,
  loading,
  onEdit,
  onDelete,
  onPublish,
  selectedIds = [],
  onSelectionChange,
  readOnly = false,
  selectable = true
}) {
  const columns = [
    {
      key: "project_name",
      label: "Project Name",
      render: (project) => (
        <Typography fontSize={14} fontWeight={600}>
          {project.project_name}
        </Typography>
      )
    },
    {
      key: "assigned_names",
      label: "Assigned To",
      render: (project) => (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {(project.assigned_names?.length > 0 ? project.assigned_names : ["-"]).map((name) => (
            <Chip
              key={name}
              label={name}
              size="small"
              sx={{ borderRadius: 2, background: "#e0f2fe", color: "#0369a1", fontWeight: 500 }}
            />
          ))}
        </Box>
      )
    },
    {
      key: "status",
      label: "Status",
      width: 120,
      render: (project) => (
        <Chip
          label={project.status === "Draft" ? "Draft" : "Published"}
          size="small"
          sx={
            project.status === "Draft"
              ? { borderRadius: 2, background: "#fef3c7", color: "#b45309", fontWeight: 600 }
              : { borderRadius: 2, background: "#dcfce7", color: "#15803d", fontWeight: 600 }
          }
        />
      )
    },
    ...(readOnly
      ? []
      : [
          {
            key: "actions",
            label: "Actions",
            width: 150,
            render: (project) => (
              <Box display="flex" justifyContent="flex-end">
                {onPublish && project.status === "Draft" && (
                  <Tooltip title="Publish">
                    <IconButton color="success" onClick={() => onPublish(project)}>
                      <PublishIcon />
                    </IconButton>
                  </Tooltip>
                )}

                <IconButton color="primary" onClick={() => onEdit(project)}>
                  <EditIcon />
                </IconButton>

                <IconButton color="error" onClick={() => onDelete(project)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            )
          }
        ])
  ];

  return (
    <DataTable
      columns={columns}
      rows={projects}
      loading={loading}
      rowKey={(project) => project.project_id}
      selectable={!readOnly && selectable}
      selectedIds={selectedIds}
      onSelectionChange={onSelectionChange}
      rowsPerPage={8}
      emptyState={{
        icon: AccountTreeRoundedIcon,
        title: "No projects found",
        subtitle: "Create a project and assign it to a user to begin tracking work by project."
      }}
    />
  );
}

export default ProjectTable;
